import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "exportDialogContent" }
const _hoisted_2 = { class: "p-float-label" }
const _hoisted_3 = {
  class: "kn-material-input-label",
  for: "label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    class: "kn-dialog--toolbar--primary exportDialog",
    visible: _ctx.visibility,
    header: _ctx.$t('common.export'),
    closable: false,
    modal: ""
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "p-button-text kn-button",
        label: _ctx.$t('common.cancel'),
        onClick: _ctx.closeDialog
      }, null, 8, ["label", "onClick"]),
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        label: _ctx.$t('common.export'),
        autofocus: "",
        disabled: _ctx.fileName && _ctx.fileName.length == 0,
        onClick: _ctx.emitExport
      }, null, 8, ["label", "disabled", "onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("span", _hoisted_2, [
          _createVNode(_component_InputText, {
            class: "kn-material-input fileNameInputText",
            type: "text",
            modelValue: _ctx.fileName,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.fileName = $event)),
            maxlength: "50"
          }, null, 8, ["modelValue"]),
          _createVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('importExport.filenamePlaceholder')), 1)
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible", "header"]))
}